import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './css/SlickCarousel.css'

type SlickCarouselProps = {
    settings: {
        dots?: boolean
        infinite?: boolean
        speed?: number
        slidesToShow?: number
        slidesToScroll?: number
        initialSlide?: number
        arrows?: boolean
        draggable?: boolean
        onInit?: any
        onReInit?: any
        responsive: {
            breakpoint: number
            settings: {
                slidesToShow: number
                slidesToScroll: number
                infinite?: boolean
                dots?: boolean
                arrows?: boolean
                draggable?: boolean
            }
        }[]
    }
    sliderRef?: any
    children: JSX.Element[]
}
const SlickCarousel: React.FC<SlickCarouselProps> = ({ settings, sliderRef, children }) => {
    return <Slider {...settings} ref={sliderRef}>{children}</Slider>
}

export default SlickCarousel
